import { type IdValuePair } from '../shared/KeyValuePair'

export enum LineType {
  part = 'part',
  labor = 'labor',
  specification = 'specification',
  graph = 'graph',
}

export interface FieldUpdate {
  field: string
  oldValue: string
  newValue: string
}

export interface HeavyDutyGroup {
  partType: string
  manufacturer: string
}

export interface Bundle {
  bundleId: number
  bundleName: string
  bundleDesc: string
}
export interface ProductModel {
  type?: LineType
  isGfx?: boolean
  lineNo?: number
  status?: string
  partNumber: string
  lineCode: string
  catLineCode?: string
  c2cURL?: string
  description?: string
  extendedDescription?: string
  orderNumber?: number
  fromYear?: string
  perCarQty?: number
  info?: string
  header?: string
  manufacturerName?: string
  manufacturerId?: string
  partType?: string
  group?: IdValuePair<string>
  heavyDutyGroup?: HeavyDutyGroup
  images?: Array<ImageLink>
  partImages?: Array<ImageLink>
  brand?: string
  brandName?: string
  brandUrl?: string
  subBrand?: string
  subBrandName?: string
  partDescriptionId?: number
  caProp65?: string
  allianceProductId?: string
  location: Array<ProductLocationModel>
  eligibleBundles?: Array<Bundle>
  replacementParts?: Array<ProductModel>
  alternateParts?: Array<ProductModel>
  terminologyId?: number
  gfxPartGreen?: boolean
  isExatcMatch?: boolean
  isLoadingPrices?: boolean

  // for parts type graph
  allianceterminologyId?: string
  weight?: number
  width?: number
  height?: number
  genericDescriptionId?: number
  unAnsweredSpecificConditions?: string[]
  isStocked?: boolean
  stockedLists?: string[]
  length?: number
  partMessage?: Array<string>
}

export interface ProductError {
  errorType: AvailabilityErrorType
  fieldUpdates?: Array<FieldUpdate>
}

export enum AvailabilityErrorType {
  NOT_TRANSFERRED,
  CANT_BE_FULFILLED, // Can't be fulfilled from any location
  CANT_BE_FULFILLED_FROM_SELECTED_LOCATION, // Can't be fulfilled from selected location, but available in other locations.
  OUT_OF_STOCK_ALL_LOCATIONS, // Can be fulfilled from the primary location, but takes more time
  PRICE_OVERRIDE,
  MIN_QTY_CHANGE,
  LOCATION_OVERRIDE,
  ORDER_FROM_NON_PRIMARY_LOCATION,
  INSUFFICIENT_QTY, // orderIfNotAvailable is true, staying on selected location despite insufficient qty
}

export interface AvailabilityError {
  errorType: AvailabilityErrorType
  fieldUpdates?: Array<FieldUpdate>
  location?: ProductLocationModel
}

export interface AvailableStores {
  partNumber?: string
  location?: Array<ProductLocationModel>
}

export interface ModelFitment {
  model: string
  perCarQty: number
  years: string
  totalApps: number
}
export interface EngineFitment {
  engine: string
  models: Array<ModelFitment>
  perCarQty: number
  totalApps: number
  years: string
}
export interface MakeFitment {
  make: string
  perCarQty: number
  totalApps: number
  years: string
  engines: Array<EngineFitment>
}

export interface VehicleFitment {
  makes: Array<MakeFitment>
}

export interface ProductLocationModel {
  locationId: string
  seqNo?: number
  locType: string
  called: string
  schedule?: string
  warrantyCode?: string
  warrantyDescription?: string
  unitOfMeasure?: string
  buyIncrement?: number
  minQty?: number
  displayMinQty?: number
  buyQty?: number
  packNumUnits: number
  qtyAvailable: number
  list: number
  cost: number
  coreList: number
  coreCost: number
  otherPrices?: Array<Price>
  priceBreaks?: Array<PriceBreakModel>
  originalBuyIncrement?: number
  originalUom?: string
  // TODO: remove the temporary next two fields after confirming the API map
  order?: string
  snCalled?: string
  estimatedDelivery?: string
  isSelected: boolean
  locationStatus?: string
}

export interface Price {
  priceCodeName: string
  priceValue: number
}

export interface PriceBreakModel {
  minQty: number
  maxQty: number
  unitCost: number
}

interface ImageLink {
  type: ImageType
  url: string
}

export enum ImageType {
  THUMBNAIL = 'thumbnail',
  LARGE = 'large',
}

export enum NonCachedSearchType {
  none,
  searchByNavigation,
  searchGfxByNavigation,
  searchByText,
  searchByInterchange,
  searchBySaytCategories,
  searchByAstNavigation,
  searchBySpecificParts,
  searchByMultiPartsInquiry,
}
